import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Image_Show_Modal from "../../../../../../common/common_modal/image_show_modal/image_show_modal";
import { formatDate } from "../../../../../../utils/common";

const Measurement_Uncertainty_Report_Table = ({
  setEdit,
  measurementdatadetails,
  currentPage,
  setCurrentPage,
}) => {
  const tableData = measurementdatadetails?.data || [];

  const totalPages = measurementdatadetails?.total_pages || 1;
  const totalEntries = measurementdatadetails?.total || 0;

  useEffect(() => {
    if (measurementdatadetails?.current_page) {
      setCurrentPage(measurementdatadetails.current_page);
    }
  }, [measurementdatadetails]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Date formatter
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const [show, setShow] = useState(false);

  const [showData, setShowData] = useState("");
  const maxObservations = Math.max(
    ...(tableData || []).map(
      (item) => item.Measurement_Uncertinity_Observations?.length || 0,
    ),
    0,
  );

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Date</th>
                <th>Parameter</th>
                <th>Measurement Period</th>
                <th colSpan={maxObservations}>Observations</th>
                <th>Standard Deviation</th>
                <th>Standard Uncertainity</th>
                <th>Reported Uncertainty </th>
                <th>Combined Uncertainity</th>
                <th>Remark</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {tableData.length > 0 ? (
                tableData?.map((row, index) => (
                  <tr key={row.id}>
                    <td>{(currentPage - 1) * 10 + index + 1}</td>
                    {/* <td>{formatDateTime(row.createdAt)}</td> */}

                    <td>{formatDate(row?.createdAt)}</td>

                    <td>{row.Parameter?.name || "-"}</td>
                    <td>{row.measurement_period || "-"}</td>

                    {Array.from({ length: maxObservations }).map(
                      (_, obsIndex) => (
                        <td key={obsIndex}>
                          {row.Measurement_Uncertinity_Observations?.[obsIndex]
                            ?.observation_value || "-"}
                        </td>
                      ),
                    )}
                    {/* //  <td>{row.observation_value || "-"}</td> */}

                    <td>{row.standard_deviation || "-"}</td>

                    <td>{row.standard_uncertainity || "-"}</td>

                    <td>{row.type_b_uncertainity || "-"}</td>

                    <td>{row.combined_uncertainity || "-"}</td>
                    
                    <td>{row.remark || "-"}</td>


                    <td>
                      <div
                        className="action_icons"
                        onClick={() => {
                          setShow(true);
                          setShowData(row);
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * 10 + 1} to{" "}
            {Math.min(currentPage * 10, totalEntries)} of {totalEntries} entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>

        <Image_Show_Modal
          onHide={() => setShow(false)}
          show={show}
          showData={showData}
          imgSrc={process.env.REACT_APP_IMG_URL + showData?.attach_file}
        />
      </div>
    </>
  );
};

export default Measurement_Uncertainty_Report_Table;
